export default {
    // 请及时审批 0 非系统状态,用于控制显示
    0: 'REMIND',
    // 审批中 1
    1: 'PENDING',
    // 审批通过 2
    2: 'PASSED',
    // 审批拒绝 3
    3: 'REFUSED',
};
